import { LinearProgress, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import Fade from '@mui/material/Fade';
import * as Preact from 'preact';
import { isSmallScreen } from './domain/theme/breakpoints';
export var Component = function (props) {
    var theme = useTheme();
    var isSmall = isSmallScreen(theme);
    return (Preact.h(Fade, { in: props.show, appear: false, timeout: { enter: 0, exit: 1800 } },
        Preact.h(Box, { sx: {
                position: 'absolute',
                display: 'flex',
                flexDirection: 'column',
                gap: isSmall ? '86px' : '114px',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                width: '100%',
                height: '100%',
                zIndex: 'modal',
            } },
            Preact.h(Box, { sx: {
                    height: isSmall ? '169px' : '198px',
                    width: isSmall ? '234px' : '317px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingTop: isSmall ? '86px' : '114px',
                } },
                Preact.h(Box, { position: "static", sx: {
                        backgroundImage: "url(".concat(props.logoSrc, ")"),
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        display: 'flex',
                        height: isSmall ? '52px' : '81px',
                        width: '100%',
                    } }),
                Preact.h(Box, { sx: {
                        height: '8px',
                        width: '100%',
                    } },
                    Preact.h(LinearProgress, { color: 'primary' })),
                Preact.h(Typography, { variant: 'h6', color: 'secondary' }, props.loadingText)),
            Preact.h(Typography, { variant: 'body2' }, props.secondaryLoadingText))));
};
Component.displayName = 'ExploreLoading';
